import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import ksolution1 from './img/ksolution1.jpg';
import ksolution2 from './img/ksolution2.jpg';
import ksolution3 from './img/ksolution3.jpg';
import ksolution4 from './img/ksolution4.jpg';
import './styles/k.css';
function Ksolution({setBannerType}){
    const history = useHistory();
    useEffect(()=> {
        setBannerType('k')
        return () => {
            console.log('url chk : ', window.location.href)
            if(window.location.href === 'http://localhost:3000/' || window.location.href === 'https://abys-service.co.kr/'){
                setBannerType('main');
            }
        }
    },[])


    const onClick = (typed) => {
        setBannerType('')
        history.push(`klist?type=${typed}`)
    }
    return (
        <div className="k-wrapper container py-5">
            <p className="top-title font-weight-bold mb-5" style={{color:'#585858',fontSize:'16px'}}>
                K-Solution<span>Premium</span>을 이용해 KIA 스팅어, K9, 모하비를 신규 계약했다면 자동차리스 이용기간 동안 횟수 제한 없이<br />
                프리미엄 차량관리 서비스를 특별 할인 가격으로 이용할 수 있습니다.
            </p>
            <div className="row p-0" style={{margin:'0 -15px'}}>
                <div className="col-md-3 col-6 mb-5"><img className="w-100 pointer" src={ksolution1} onClick={() => onClick('유리막코팅')}/></div>
                <div className="col-md-3 col-6 mb-5"><img className="w-100 pointer" src={ksolution2} onClick={() => onClick('가죽코팅')}/></div>
                <div className="col-md-3 col-6"><img className="w-100 pointer" src={ksolution3} onClick={() => onClick('실내클리닝')}/></div>
                <div className="col-md-3 col-6"><img className="w-100 pointer" src={ksolution4} onClick={() => onClick('광택')}/></div>
            </div>
            <div className="mt-5">
                <p className="font-weight-bold" style={{color:'#00479D',fontSize:'16px'}}>유의사항</p>
                <p className="bottom-title font-weight-bold">
                    - 본 서비스는 현대캐피탈 K-Solution<span>Premium</span>이용 고객에게만 제공됩니다.
                </p>
                <p className="bottom-title font-weight-bold">
                    - 서비스를 변경하시거나 추가하고 싶으신분은 서비스 매장에서 상담을 진행해 주세요.
                </p>
                <p className="bottom-title font-weight-bold">
                    - 본 서비스는 타인에게 승계할 수 없습니다.
                </p>
            </div>
        </div>
    )
}

export default Ksolution;